<template>
  <div class="vf-m-catalog-info">
    <h1>
      {{ visibleHeading }}
    </h1>
  </div>
</template>
<script lang="ts" setup>
import { computed } from "vue";

const props = defineProps({
  category: {
    type: Object,
    default() {
      return null;
    },
  },
});

const normalizeHeading = (value: unknown) =>
  String(value || "")
    .replace(/\s+/g, " ")
    .trim();

const visibleHeading = computed(
  () =>
    normalizeHeading(props.category?.h1) ||
    normalizeHeading(props.category?.name)
);
</script>
